import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-3" }
const _hoisted_2 = { class: "px-6 py-3" }
const _hoisted_3 = { class: "space-y-6" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_6 = { class: "px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_7 = { class: "px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_8 = { class: "px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_9 = { class: "px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_10 = { class: "px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_11 = { class: "px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_12 = { class: "px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import FilterComponent from '@/components/FilterComponent.vue';
import DataTable from '@/components/DataTable.vue';
import TabComponent from '@/components/TabComponent.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import PagePagination from '@/components/PagePagination.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import StatusPill from '@/components/StatusPill.vue';
import { ref, onMounted, watch } from 'vue';
import { paginatePage } from '@/helpers/PageHelper';
import ReportService from '@/classes/ReportService';
import { startOfYear, endOfYear } from 'date-fns';
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';
import { formatDate, formatDateTime } from '@/helpers/TimeFormatter'
import throttle from "lodash/throttle";

interface newMember {
    first_name: string,
    last_name: string,
    hospital_no: string,
}

interface Item {
    data: newMember[]
    total: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NewMember',
  setup(__props) {

const loader      = ref(false);
const showSuccess = ref(false);
const showError   = ref(false);
const errorMsg    = ref();
const goToPage    = ref();
const patientType = ref(null)

const items = ref<Item>({
    data: [],
    total: 0
});

const dateRange = ref([
    startOfYear(new Date).toISOString(),
    endOfYear(new Date).toISOString(),
]);
const bookingDateRange = ref([
    startOfYear(new Date).toISOString(),
    endOfYear(new Date).toISOString(),
]);

const headers: { text: string }[] = [
    { text: 'Patient Name' },
    { text: 'Patient Type' },
    { text: 'Company' },
    { text: 'Patient ID' },
    { text: 'Booking type' },
    { text: 'Status' },
    { text: 'Booking Date and time' },
    { text: 'Date Created' },
];

const applyFilters = () => {
    fetchNewMembers(goToPage.value);
}

const fetchNewMembers = async (data: string) => {
    try {
        loader.value = true;

        const startDate = dateRange.value ? `&startDate=${dateRange.value[0]}` : '';
        const endDate   = dateRange.value ? `&endDate=${dateRange.value[1]}` : '';
        const bookingStartDate   = bookingDateRange.value ? `&bookingDateStart=${bookingDateRange.value[0]}` : '';
        const bookingEndDate   = bookingDateRange.value ? `&bookingDateEnd=${bookingDateRange.value[1]}` : '';
        const patientTypeQuery = patientType.value ? `&patientType=${patientType.value}` : '';
        
        goToPage.value = paginatePage(data)

        const queryString = searchText.value ? `&search_key=${searchText.value}` : '';

        const response   = await ReportService.fetchNewMembers(`${goToPage.value}${startDate}${endDate}${patientTypeQuery}${bookingStartDate}${bookingEndDate}${queryString}`);
        loader.value = false;
        
        items.value = response.data;
    } catch (error: any) {
            loader.value    = false;
            showError.value = true;
            errorMsg.value  = error;

            if(error.response.status == 401) {
                window.location.replace('/login');
            }
    }
    finally{
        loader.value = false
    }
}

const exportNewMembers = async () => {
    try {
        loader.value = true;
        const startDate = dateRange.value ? `?startDate=${dateRange.value[0]}` : '';
        const endDate   = dateRange.value ? `&endDate=${dateRange.value[1]}` : '';
        const bookingStartDate   = bookingDateRange.value ? `&bookingDateStart=${bookingDateRange.value[0]}` : '';
        const bookingEndDate   = bookingDateRange.value ? `&bookingDateEnd=${bookingDateRange.value[1]}` : '';
        const patientTypeQuery = patientType.value ? `&patientType=${patientType.value}` : '';
        const queryString = searchText.value ? `&search_key=${searchText.value}` : '';

        await ReportService.exportNewMembers(`${startDate}${endDate}${patientTypeQuery}${bookingStartDate}${bookingEndDate}${queryString}`);

        showSuccess.value = true;
    } catch (error: any) {
        showError.value = true;
        errorMsg.value  = error.response?.data.message;
    } finally {
        loader.value = false;
    }
};

const patientTypes = [
    { id: '1', label: 'All', value: 'All' },
    { id: '2', label: 'Individual', value: 'Individual' },
    { id: '3', label: 'Corporate', value: 'Corporate' },
    { id: '4', label: 'Dependent', value: 'Dependent' },
];

const getStatusColor = (status: string) => {
    if(status) {
        let color = null;
        switch (status) {
            case 'Booked':
                color = 'blue';
                break;
        
            case 'Cancelled/No-Show':
            case 'Cancelled':
                color = 'red';
                break;
        
            case 'Done':
                color = 'green';
                break;
            
            default:
                color = 'yellow'
                break;
        }

        return color;
    }

    return 'yellow';
}

const searchText = ref();

const searchData = (val: string) => {
    searchText.value = val
}

/**
 * ********************************
 * Wathchers 
 * ********************************
 */
watch(
    searchText,
    throttle(() => {
        fetchNewMembers(goToPage.value)
    }, 1000)
);

onMounted(() => { fetchNewMembers(goToPage.value); })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "Number of New Members",
    "show-back": "",
    backUrl: "/reports"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(TabComponent, { "button-items": true }, {
          buttons: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(ButtonComponent, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (exportNewMembers())),
                class: "text-gray-900",
                secondary: "",
                exportBtn: ""
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode(" Export ", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(FilterComponent, {
          "text-filters": false,
          "onUpdate:filters": applyFilters,
          textFilters: "",
          search: searchText.value,
          onFetchData: searchData
        }, {
          fields: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(DatePicker, {
                id: "dateRange",
                name: "dateRange",
                range: "",
                is24: "",
                isPresetRanges: "",
                modelValue: bookingDateRange.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((bookingDateRange).value = $event)),
                placeholder: "Booking Date",
                label: "Booking Date"
              }, null, 8, ["modelValue"]),
              _createVNode(DatePicker, {
                id: "dateRange",
                name: "dateRange",
                range: "",
                is24: "",
                isPresetRanges: "",
                modelValue: dateRange.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dateRange).value = $event)),
                placeholder: "Start Date & End Date",
                label: "Start Date & End Date"
              }, null, 8, ["modelValue"]),
              _createVNode(MultiselectInput, {
                modelValue: patientType.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((patientType).value = $event)),
                id: "patientType",
                name: "patientType",
                label: "Patient Type",
                placeholder: "Patient Type",
                options: patientTypes
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["search"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(DataTable, {
          headers: headers,
          noAction: true,
          count: items.value?.total
        }, {
          body: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value?.data, (newMember, key) => {
              return (_openBlock(), _createElementBlock("tr", { key: key }, [
                _createElementVNode("td", _hoisted_5, _toDisplayString(newMember.first_name + ' ' + newMember.last_name), 1),
                _createElementVNode("td", _hoisted_6, _toDisplayString(newMember?.patient_type ?? '--'), 1),
                _createElementVNode("td", _hoisted_7, _toDisplayString(newMember?.company_name ?? '--'), 1),
                _createElementVNode("td", _hoisted_8, _toDisplayString(newMember?.patient_id ?? '--'), 1),
                _createElementVNode("td", _hoisted_9, _toDisplayString(newMember?.booking_type ?? '--'), 1),
                _createElementVNode("td", _hoisted_10, [
                  _createVNode(StatusPill, {
                    color: getStatusColor(newMember.booking_status),
                    text: newMember.booking_status
                  }, null, 8, ["color", "text"])
                ]),
                _createElementVNode("td", _hoisted_11, [
                  (newMember?.booking_datetime)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(`${_unref(formatDateTime)(newMember.booking_datetime)}`), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" -- ")
                      ], 64))
                ]),
                _createElementVNode("td", _hoisted_12, _toDisplayString(`${_unref(formatDate)(newMember.created_date)}`), 1)
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["count"]),
        _createVNode(PagePagination, {
          class: "mb-6",
          items: items.value,
          onNextPage: fetchNewMembers
        }, null, 8, ["items"])
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[4] || (_cache[4] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[5] || (_cache[5] = ($event: any) => (showSuccess.value = false)),
        "action-text": "Close",
        title: "New Members Export",
        content: "Export is being processed. Please check your registered email."
      }, null, 8, ["show"]),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[6] || (_cache[6] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[7] || (_cache[7] = ($event: any) => (showError.value = false))
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})